var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDragNDropFilesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 325,
    height: 154.835,
    viewBox: "0 0 325 154.835",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2495",
    "data-name": "Group 2495",
    transform: "translate(-1072 -538.165)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Typography_TAG:H5_",
    "data-name": "Typography [TAG:H5]",
    transform: "translate(1072 626)",
    fill: "#adaeb8",
    fontSize: 24,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 70.174,
    y: 18
  }, "Drag n&apos; Drop files"), /*#__PURE__*/React.createElement("tspan", {
    x: 79.109,
    y: 52
  }, "to upload easily ")), /*#__PURE__*/React.createElement("g", {
    id: "Group_1951",
    "data-name": "Group 1951",
    transform: "translate(-131.275 111.586)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1950",
    "data-name": "Group 1950",
    transform: "translate(1327.263 437.111) rotate(-9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Area",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#adaeb8",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.323,
    height: 67.323,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 65.323,
    height: 65.323,
    rx: 7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(13.016 13.016)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Area-2",
    "data-name": "Area",
    width: 41.291,
    height: 41.291,
    transform: "translate(0 0)",
    fill: "#fcfcfc",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-2",
    "data-name": "Icon",
    transform: "translate(6.883 3.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M17.2,0H3.441A3.441,3.441,0,0,0,0,3.441V30.968a3.441,3.441,0,0,0,3.441,3.441H24.087a3.441,3.441,0,0,0,3.441-3.441V10.323Z",
    transform: "translate(0 0)",
    fill: "rgba(0,0,0,0)",
    stroke: "#adaeb8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M0,0V10.323H10.323",
    transform: "translate(17.205 0)",
    fill: "rgba(0,0,0,0)",
    stroke: "#adaeb8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line",
    x1: 13.764,
    transform: "translate(6.882 18.925)",
    fill: "none",
    stroke: "#adaeb8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line-2",
    "data-name": "Line",
    x1: 13.764,
    transform: "translate(6.882 25.807)",
    fill: "none",
    stroke: "#adaeb8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M3.441,0H0",
    transform: "translate(6.882 12.043)",
    fill: "rgba(0,0,0,0)",
    stroke: "#adaeb8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Icon-3",
    "data-name": "Icon",
    transform: "translate(1377.415 439.44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-4",
    "data-name": "Icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "M2.5,2.5,7.818,15.263,9.7,9.7l5.559-1.887Z",
    transform: "translate(-2.5 -2.5)",
    fill: "#adaeb8",
    stroke: "#adaeb8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    "data-name": "Path",
    d: "M10.833,10.833l4.513,4.513",
    transform: "translate(-3.312 -3.312)",
    fill: "#fff",
    stroke: "#adaeb8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragNDropFilesIcon);
export default __webpack_public_path__ + "static/media/drag_n_drop_files_icon.e17a427b68d1476d2e1c52347b5abea9.svg";
export { ForwardRef as ReactComponent };